import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { ifNotZero } from '../../helpers';

const SearchDetails = ({ details, onModify }) => {
	if (!details?.strSectorFrom) return null;

	return (
		<div className="flights-search-summary card shadow-sm mb-3">
			<div className="card-body p-3">
				<div className="flights-search-summary__route">
					<span className="flights-search-summary__code">{details.strSectorFrom}</span>
					<i
						className={details.strTripType === 'O' ? 'fas fa-arrow-right' : 'fas fa-exchange-alt'}
						aria-hidden="true"
					/>
					<span className="flights-search-summary__code">{details.strSectorTo}</span>
				</div>
				<div className="flights-search-summary__meta">
					<span>
						<i className="fas fa-calendar-alt text-primary" aria-hidden="true" />{' '}
						{moment(details.strFlightDate).format('D MMM YYYY')}
					</span>
					{details.strTripType === 'R' && details.strReturnDate && (
						<span>
							<i className="fas fa-calendar-alt text-primary" aria-hidden="true" /> Return{' '}
							{moment(details.strReturnDate).format('D MMM YYYY')}
						</span>
					)}
					<span>
						<i className="fas fa-user text-primary" aria-hidden="true" /> {details.intAdult} adult
						{ifNotZero(details.intChild, `, ${details.intChild} child`)}
					</span>
				</div>
				<button type="button" className="btn btn-sm btn-outline-primary flights-search-summary__modify" onClick={onModify}>
					Modify search
				</button>
			</div>
		</div>
	);
};

export default connect(({ flightStore }) => ({
	details: flightStore.searchDetails,
}))(SearchDetails);
